import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../core/auth.service';

/**
 * نقطة في سلسلة تسجيل الخروج الموحّد: تمسح توكنات البوابة المحلية ثم تنتقل إلى ?next=
 */
@Component({
  standalone: true,
  imports: [CommonModule],
  template: `
    <p style="padding: 2rem; text-align: center; font-family: sans-serif">
      جارٍ إنهاء الجلسة في جميع الأنظمة…
    </p>
  `,
})
export class LogoutCallbackComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private auth = inject(AuthService);

  ngOnInit(): void {
    this.auth.clearLocalSessionOnly();
    const next = this.route.snapshot.queryParamMap.get('next');
    if (next) {
      window.location.href = next;
    } else {
      void this.router.navigateByUrl('/login');
    }
  }
}
